<mat-form-field subscriptSizing="dynamic" class="full-width">
  <mat-label>{{ label }}</mat-label>
  <input matInput [inputMask]="numberInputMask" [placeholder]="placeholder" [formControl]="formItem" />
  @if (formItem.hasError('required')) {
    <mat-error>Telefon nummer er påkrævet</mat-error>
  }
  @if (formItem.hasError('invalidPhoneNumber')) {
    <mat-error>{{ formItem.getError('invalidPhoneNumber') }}</mat-error>
  }
  @if (hintText) {
    <mat-hint class="tiny-text">{{ hintText }}</mat-hint>
  }
</mat-form-field>
